import { createContext, type Dispatch, type SetStateAction } from "react";
import { UrlUpdateType } from "use-query-params";
import { Invoice, InvoiceSortValue } from "@common/types/invoice";
import { InvoiceFilters } from "@common/contracts/invoice.contract";
import type { LoadMoreTableState } from "@hooks/useLoadMoreTableState";
import { UseSort } from "./useSort";

export interface PaginatedInvoicesTableContextValue {
    currentPage: number;
    totalPages: number;
    invoiceCount: number;
    setPage:
        | Dispatch<SetStateAction<number>>
        | ((
              newValue: number | null | undefined,
              updateType?: UrlUpdateType,
          ) => void);
    handleSortChange: UseSort["handleSortChange"];
    currentSort: UseSort["currentSort"];
    invoices?: Invoice[];
    isLoading: boolean;
    // The resolved API filters backing the current page's invoices query;
    // used to scope the command bar's total/average/count stats query the
    // same way the invoices themselves are scoped (PRO-11992).
    filters: InvoiceFilters;
    /** Set when the table loads more on scroll instead of paging. */
    loadMore?: LoadMoreTableState;
}

const defaultValue: PaginatedInvoicesTableContextValue = {
    currentPage: 0,
    totalPages: 0,
    invoiceCount: 0,
    setPage: () => {},
    handleSortChange: () => {},
    currentSort: InvoiceSortValue.NONE,
    isLoading: false,
    filters: {},
};

export const PaginatedInvoicesTableContext =
    createContext<PaginatedInvoicesTableContextValue>(defaultValue);
